import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {AppTerms} from "../../app/app-terms";
import {EntitySelectionComposer} from "../entity-selection/entity-selection-composer";
import {Tooltip} from "../tooltip/tooltip";
import {WithTerms} from "../composers/with-terms";
import {TrashImageRequestParams} from "../../icons/trash.image-request-params";
import {TRASH_ICON_SIZES} from "../../consts";
import {SVGImage} from "../image/svg-image";
import {useThemeColor} from "../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../app/consts/colors";

export class TrashIconProps extends BaseProps {
  i18n: AppTerms;
  onClick: Function;
  size: Number;
  tooltipTitle: String;
}

export const TrashIcon = WithTerms(EntitySelectionComposer((props: TrashIconProps) => {
  const starProps = {
    style: {
      cursor: 'pointer',
      ...props.style
    },
    fillcolor: useThemeColor(COLORS.dangerPrimary),
    width: props.size || 14,
    height: props.size || 16,
    className: 'pointer',
    src: new TrashImageRequestParams(TRASH_ICON_SIZES.width, TRASH_ICON_SIZES.height),
    title: props.tooltipTitle,
    onClick: (e) => props.onClick(e),
  }

  return (
    <Tooltip className={'trash-icon-container'} title={props.tooltipTitle}>
      <SVGImage {...starProps}/>
    </Tooltip>
  );
}));
